import { financialYearCode, financialYearWithCode, monthWithCode } from "../DB/MonthDb";

 export const isAgeInRange = (minAge, maxAge, selectedRange) => {
  if (selectedRange === "All" || selectedRange === "") return true;

 
  // minAge = minAge ?? 0;
  // maxAge = maxAge ?? 200;

  // switch (selectedRange) {
  //   case "0-17":
  //     return minAge <= 17;
  //   case "18-35":
  //     return minAge <= 35 && maxAge >= 18;
  //   case "36-50":
  //     return minAge <= 50 && maxAge >= 36;
  //   case "51+":
  //     return maxAge >= 51;
  //   default:
  //     return true;
  // }
};
export function capitalizeWord(word) {
  if (!word) return ""; // handle empty/null
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

export const convertToMMDDYYYY = (dateStr) => {
  if (!dateStr) return "";

  // Expecting input in "dd-mm-yyyy"
  const parts = dateStr.split("-");
  if (parts.length !== 3) return "";

  const [day, month, year] = parts;

  // Basic validation
  if (isNaN(day) || isNaN(month) || isNaN(year)) return "";

  return `${month}-${day}-${year}`;
};



const toMinutes = (timeStr) => {
  const [time, modifier] = timeStr.split(" ");
  let [hours, minutes] = time.split(":").map(Number);

  if (modifier === "PM" && hours !== 12) {
    hours += 12;
  }
  if (modifier === "AM" && hours === 12) {
    hours = 0;
  }

  return hours * 60 + minutes;
};


const toTimeString = (minutes) => {
  let hrs = Math.floor(minutes / 60);
  let mins = minutes % 60;
  const modifier = hrs >= 12 ? "PM" : "AM";

  if (hrs === 0) hrs = 12;
  else if (hrs > 12) hrs -= 12;

  return `${hrs.toString().padStart(2, "0")}:${mins
    .toString()
    .padStart(2, "0")} ${modifier}`;
};

// Function to generate ranges
 export const generateTimeRanges = (
  timeInterval,
  duration = 120, // 2 hours
  step = 30       // 30 minutes
) => {
  const ranges = [];

  const toMinutes = (time) => {
    const [t, modifier] = time.split(" ");
    let [hours, minutes] = t.split(":").map(Number);

    if (modifier === "PM" && hours !== 12) hours += 12;
    if (modifier === "AM" && hours === 12) hours = 0;

    return hours * 60 + minutes;
  };

  const toTimeString = (minutes) => {
    const hrs = Math.floor(minutes / 60);
    const mins = minutes % 60;

    const period = hrs >= 12 ? "PM" : "AM";
    const hour12 = hrs % 12 === 0 ? 12 : hrs % 12;

    return `${String(hour12).padStart(2, "0")}:${String(mins).padStart(
      2,
      "0"
    )} ${period}`;
  };

  for (let i = 0; i < timeInterval.length; i++) {
    const start = timeInterval[i];
    const startMin = toMinutes(start);

    // take only 30-minute steps
    if (startMin % step !== 0) continue;

    const endMin = startMin + duration;
    const endTime = toTimeString(endMin);

    // end time must exist in interval list
    if (!timeInterval.includes(endTime)) continue;

    ranges.push(`${start} - ${endTime}`);
  }

  return ranges;
};



export const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  export const formatScheduleDate = (date) => {
    const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
  const yyyy = date.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
  }

  // Format date-of-birth for display in UI. Accepts Date object or various string forms.
  export const formatDobDisplay = (dob) => {
    if (!dob && dob !== 0) return "";

    // If already a Date object
    if (dob instanceof Date && !isNaN(dob)) return formatScheduleDate(dob);

    // If string like 'yyyy-mm-dd' or 'yyyy-mm-ddTHH:MM:SS' -> convert to dd-mm-yyyy
    if (typeof dob === "string") {
      const isoPart = dob.split("T")[0];
      if (/^\d{4}-\d{2}-\d{2}$/.test(isoPart)) return formatDate(isoPart);

      // If value already in dd-mm-yyyy format
      if (/^\d{2}-\d{2}-\d{4}$/.test(dob)) return dob;

      // Try parsing as Date and format
      const parsed = new Date(dob);
      if (!isNaN(parsed)) return formatScheduleDate(parsed);

      // fallback to raw string
      return dob;
    }

    // other types: coerce to string
    try {
      return String(dob);
    } catch (e) {
      return "";
    }
  };

// const dropdownOptions = generateTimeRanges(timeInterval, 60); // 60 min duration
// console.log(dropdownOptions);
// schdule date and Time for booking section
export function parseTime(timeStr) {
  const [time, modifier] = timeStr.split(" ");
  let [hours, minutes] = time.split(":").map(Number);

  if (modifier === "PM" && hours !== 12) hours += 12;
  if (modifier === "AM" && hours === 12) hours = 0;

  return { hours, minutes };
}

function formatTime(hours, minutes) {
  const period = hours >= 12 ? "PM" : "AM";
  let h = hours % 12;
  if (h === 0) h = 12; // handle midnight/noon
  return `${String(h).padStart(2, "0")}:${String(minutes).padStart(2, "0")} ${period}`;
}

export function calculateSlots(fromTime, toTime, slotMinutes) {
  const { hours: fromH, minutes: fromM } = parseTime(fromTime);
  const { hours: toH, minutes: toM } = parseTime(toTime);

  let start = new Date();
  start.setHours(fromH, fromM, 0, 0);

  let end = new Date();
  end.setHours(toH, toM, 0, 0);

  const slots = [];
  while (start < end) {
    const hours = start.getHours();
    const minutes = start.getMinutes();
    slots.push(formatTime(hours, minutes));
    start.setMinutes(start.getMinutes() + slotMinutes);
  }

  return slots;
}




// export function groupSlotsByPeriod(slots, bookedData = []) {
//   const grouped = { Morning: [], Afternoon: [], Evening: [] };

//   // get only booked times where SlotStatus = BOOKED
//   const bookedTimes = bookedData
//     .filter((b) => b.SlotStatus === "BOOKED")
//     .map((b) => b.AppTime);

//   slots.forEach((slot) => {
//     const [time, modifier] = slot.split(" ");
//     let [hours] = time.split(":").map(Number);

//     if (modifier === "PM" && hours !== 12) hours += 12;
//     if (modifier === "AM" && hours === 12) hours = 0;

//     // mark slot with booked flag
//     const slotObj = {
//       label: slot,
//       booked: bookedTimes.includes(slot),
//     };

//     if (hours < 12) grouped.Morning.push(slotObj);
//     else if (hours < 17) grouped.Afternoon.push(slotObj);
//     else grouped.Evening.push(slotObj);
//   });

//   return grouped;
// }

export function groupSlotsByPeriod(slotObjs = []) {
  const grouped = { Morning: [], Afternoon: [], Evening: [] };

  slotObjs.forEach((slot) => {
    const [time, modifier] = slot.label.split(" ");
    let [hours] = time.split(":").map(Number);

    if (modifier === "PM" && hours !== 12) hours += 12;
    if (modifier === "AM" && hours === 12) hours = 0;

    if (hours < 12) grouped.Morning.push(slot);
    else if (hours < 17) grouped.Afternoon.push(slot);
    else grouped.Evening.push(slot);
  });

  return grouped;
}




//getting financial Year //

export const parseBillId = (billId) => {
  if (!billId || billId.length < 2) return null;

  const yearCode = billId.charAt(0).toUpperCase(); // first char
  const monthCode = billId.charAt(1).toUpperCase(); // second char

  // find year
  const yearIndex = financialYearCode.indexOf(yearCode);
  const financialYear =
    yearIndex !== -1 ? financialYearWithCode[yearIndex] : null;

  // find month
  const monthIndex = monthWithCode.indexOf(monthCode);
  const month = monthIndex !== -1 ? monthIndex + 1 : null; // 1–12

  return {
    yearCode,
    financialYear,
    monthCode,
    month,
  };
};

export const showFieldError = (touchedFields, fieldErrors, fieldName) => {
  const localTouched = touchedFields && touchedFields[fieldName];
  return localTouched && fieldErrors[fieldName];
};

// helper.js

export const toBase64Raw = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = () => {
      // Remove the prefix (image/pdf etc.)
      const base64 = reader.result.split(",")[1];
      resolve(base64);
    };

    reader.onerror = (err) => reject(err);
  });
};


export function getDepartmentInfo(departmentName) {
    const departments = {
        'CT-SCAN': { 
            className: 'radiologyBGSection',
            title: 'CT SCAN',
        },
        'X-RAY': { 
            className: 'xray-page',
            title: 'X RAY',
        },        
        'CARDIOLOGY': { 
            className: 'cardiologyBGSection',
            title: 'CARDIOLOGY',
            
        },
        'MRI': { 
            className: 'radiologyBGSection',
            title: 'MRI',
            
        },
      
          'USG': {
            className: 'radiologyBGSection',
            title: 'ULTRASONOGRAPHY',
            

          },
         "Gastrology":{
          className: 'gastroenterologyBgSection',
            title: 'Gastroenterology',

         },
         "NEUROLOGY" : {
          className:'neurologyBGSection',
          title: 'NEUROLOGY'
         },
         'Urology': {
          className:'urologyBGSection',
          title: 'UROLOGY'
         },
         'Pulmonology':{
          className:'pulmonologybgSection',
          title: 'Pulmonology,'
          
         },
         'PHYSIOTHERAPY':{
          className:'physiotherapyBGSection',
          title:'Physiotherapy'
         },
         'Home Care ' : {
          className: 'homecareBGSection',
          title:'Home Care'
         },
         'EYE ' : {
          className:'OphthalmologyBGSection',
          title:'Ophthalmology'
         },
         'DENTAL' : {
          className:'dentalBGSection',
          title : 'Dental',
         },
         'DERMA' : {
          className : 'dermatologyBGSection',
          title : 'Dermatology'
         },
        //  'Biochemistry' : {
        //   className : ''
        //  }




        
    };
    return departments[departmentName];
}

export const parseDateChange = (value) => {

  if (!value) return null;

  // If already Date object
  if (value instanceof Date) return value;

  // If format: yyyy-mm-dd
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return new Date(value);
  }

  // If format: dd/mm/yyyy
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
    const [day, month, year] = value.split("/");
    return new Date(`${year}-${month}-${day}`);
  }
  
  // If format: dd-mm-yyyy
  if (/^\d{2}-\d{2}-\d{4}$/.test(value)) {
    const [day, month, year] = value.split("-");
    return new Date(`${year}-${month}-${day}`);
  }
  return null;
};
export const getWeekDayName = (offset = 0) => {
  const date = new Date();
  date.setDate(date.getDate() + offset);
  return date.toLocaleDateString("en-US", { weekday: "long" });
};

export const getDateInString = (date) => {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};
export const toCamelCase = (text = "") => {
  return text
    .toLowerCase()
    .split(" ")
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const getIosDateString = (dateStr) => {
  if (!dateStr) return null;
  const [day, month, year] = dateStr.split("-");

  return `${year}-${month}-${day}`;
};

// convert yyyy-mm-dd to dd-mm-yyyy
export const convertToDDMMYYYY = (dateStr) => {
  if (!dateStr) return "";
  const parts = dateStr.split("-");
  if (parts.length !== 3) return "";
  const [year, month, day] = parts;
  return `${day}/${month}/${year}`;
};
export const diffInDays = (d1, d2) =>
  Math.abs(Math.ceil((d2 - d1) / (1000 * 60 * 60 * 24)));

 export const getSelectedBillCount = (selectedReport = {}) => {
  return Object.keys(selectedReport).length;
};




const isPastTimeSlot = (slotLabel, selectedDate) => {
  if (!slotLabel || !selectedDate) return false;

  const now = new Date();

  const [time, meridiem] = slotLabel.split(" ");
  let [hours, minutes] = time.split(":").map(Number);

  if (meridiem === "PM" && hours !== 12) hours += 12;
  if (meridiem === "AM" && hours === 12) hours = 0;

  const [dd, mm, yyyy] = selectedDate.split("-").map(Number);

  const slotDate = new Date(yyyy, mm - 1, dd, hours, minutes, 0);

  return slotDate.getTime() < now.getTime(); // ✅ BOOLEAN
};

export const cleanText = (text) =>
  text
    ?.replace(/\u00A0/g, " ")   // remove NBSP
    ?.replace(/\s+/g, " ")     // remove double spaces
    ?.trim();
